/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { hideVideoDebugOverlay } from '../../videoplayer/videodebugoverlay/videodebugoverlay.reducers';
import {
    deleteLastEnteredChannelDigit,
    hideStandardInfo,
    setEnteringChannelNumberEnabled,
    showFullInfo,
    showTrickPlayMenu,
    tuneToEnteredChannelNumber,
    updateStandardInfoBannerTimer,
} from './infobanner.reducers';

export const onKeyBackStandardInfoBanner = () => (dispatch: Function, getState: Function) => {
    const { isVideoDebugOverlayActive } = getState().videoDebugOverlay;
    if (isVideoDebugOverlayActive) {
        dispatch(hideVideoDebugOverlay());
    }
    dispatch(hideStandardInfo());
};

export const onKeyLeftStandardInfoBanner = () => (dispatch: Function, getState: Function) => {
    const { infoBanner } = getState();
    const { enteringChannelNumberEnabled } = infoBanner;
    if (enteringChannelNumberEnabled) {
        dispatch(deleteLastEnteredChannelDigit());
    }
};

export const onKeyOkStandardInfoBanner = () => (dispatch: Function, getState: Function) => {
    const { enteringChannelNumberTimeoutId, enteringChannelNumberEnabled } = getState().infoBanner;
    if (enteringChannelNumberEnabled) {
        dispatch(tuneToEnteredChannelNumber());
        clearTimeout(enteringChannelNumberTimeoutId);
        dispatch(setEnteringChannelNumberEnabled(false));
    } else dispatch(showTrickPlayMenu());
};

export const onKeyRightStandardInfoBanner = () => (dispatch: Function, getState: Function) => {
    const { infoBanner } = getState();
    const { enteringChannelNumberEnabled } = infoBanner;
    if (enteringChannelNumberEnabled) {
        dispatch(tuneToEnteredChannelNumber());
    }
};

export const onKeyInfoStandardInfoBanner = () => (dispatch: Function) => {
    dispatch(showFullInfo());
};

export const onKeyChannelDownStandardInfoBanner = () => (dispatch: Function) => {
    dispatch(updateStandardInfoBannerTimer());
};

export const onKeyChannelUpStandardInfoBanner = () => (dispatch: Function) => {
    dispatch(updateStandardInfoBannerTimer());
};
